import EmptyFleet from "#images/fleet-aircraft.png"
import { AircraftGeneralInfoModal } from "#pages/authenticated/fleet/components/add-aircraft.tsx"

export const Empty = () => {
  return (
    <div className="flex flex-col items-center justify-center gap-2">
      <img src={EmptyFleet} alt="empty fleet" className="h-50" />
      <div className="flex flex-col items-center gap-2 text-center">
        <p className="text-foreground text-[20px] font-semibold">
          No aircraft in fleet yet
        </p>
        <p className="text-muted-foreground text-sm">
          Add your first aircraft profile to start tracking <br /> operations, documents,
          flights, and expenses
        </p>
        <AircraftGeneralInfoModal />
      </div>
    </div>
  )
}
